import { render, staticRenderFns } from "./RoleCheckbox.vue?vue&type=template&id=667147ae"
import script from "./RoleCheckbox.vue?vue&type=script&lang=js"
export * from "./RoleCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports